import { CONSTANTS } from './vars';

export default function getLocalWishlist() {
  try {
    const wishlist = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_WISHLIST_KEY);
    if (!wishlist) return [];
    return wishlist.split(CONSTANTS.LOCAL_STORAGE_DELIMITER).filter(Boolean);
  } catch {
    return [];
  }
}
